module.exports = __webpack_public_path__ + "static/media/dtrans_p02kz.6426fab2.pdf";